<template>
  <ServicePageLayout
    title="CMMS Dashboard"
    subtitle="ภาพรวมงานบำรุงรักษา"
    icon="mdi-tools"
    breadcrumb="Operations"
  >
    <v-tabs v-model="tab" class="industrial-tabs">
      <v-tab>งานบำรุงรักษา รายวัน</v-tab>
      <v-tab>งานบำรุงรักษา เทียบแผน</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><PM_DAILY /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><PM_MONTHLY /></v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'
import PM_DAILY from '@/components/cmms/pm_daily.vue'
import PM_MONTHLY from '@/components/cmms/pm_monthly.vue'

export default {
  name: 'CMMSDashboard',
  components: {
    ServicePageLayout,
    PM_DAILY,
    PM_MONTHLY
  },
  data() {
    return { tab: null }
  },
}
</script>
